// extracted by mini-css-extract-plugin
export default {"form":"home_form__JrKjB"};